import {
  AIIcon,
  ChannelIcon,
  ChatIcon,
  IntegrationsIcon,
  MailIcon,
  OperatorAnalyticsIcon,
  ScenarioIcon,
  SettingsIcon,
  ShopIcon,
  StatsIcon,
  UsersIcon
} from 'shared/newComponents/icons';
import { ComponentType } from 'shared/entities/components/Component';
import { urls } from 'shared/entities/domain';
import { IntegrationTypeAll } from 'shared/entities/integrations';
import { MenuSectionItem } from 'shared/newEntities/components/MenuSection';
import PaletteIcon from 'shared/newComponents/icons/PaletteIcon';

export const getSections = (projectId: string | null): MenuSectionItem[] => {
  return [
    {
      Icon: AIIcon,
      title: (t) =>
        t('PageTemplate.Sections.ai', {
          ns: 'newComponents'
        }),
      action: {
        type: ComponentType.link,
        to: projectId
          ? urls.PROJECT.tabs.SMARTBOT_AI.LIST.create({
              projectId
            })
          : '',
        mask: urls.PROJECT.tabs.SMARTBOT_AI.mask
      }
    },
    {
      Icon: ScenarioIcon,
      title: (t) =>
        t('PageTemplate.Sections.scenarios', {
          ns: 'newComponents'
        }),
      action: {
        type: ComponentType.link,
        to: projectId
          ? urls.PROJECT.tabs.SCENARIOS.COMMON.create({
              projectId
            })
          : '',
        mask: urls.PROJECT.tabs.SCENARIOS.mask
      }
    },
    {
      Icon: MailIcon,
      title: (t) =>
        t('PageTemplate.Sections.mailings', {
          ns: 'newComponents'
        }),
      action: {
        type: ComponentType.link,
        to: projectId
          ? urls.PROJECT.tabs.MAILINGS.GENERAL.create({
              projectId
            })
          : '',
        mask: urls.PROJECT.tabs.MAILINGS.mask
      }
    },
    {
      Icon: ChatIcon,
      title: (t) =>
        t('PageTemplate.Sections.chats', {
          ns: 'newComponents'
        }),
      action: {
        type: ComponentType.link,
        to: projectId
          ? urls.PROJECT.tabs.CONVERSATIONS.create({
              projectId
            })
          : '',
        mask: urls.PROJECT.tabs.CONVERSATIONS.mask
      }
    },
    {
      Icon: UsersIcon,
      title: (t) =>
        t('PageTemplate.Sections.users', {
          ns: 'newComponents'
        }),
      action: {
        type: ComponentType.link,
        to: projectId
          ? urls.PROJECT.tabs.USERS.TABLE.create({
              projectId
            })
          : '',
        mask: urls.PROJECT.tabs.USERS.mask
      }
    },
    {
      Icon: ShopIcon,
      title: (t) =>
        t('PageTemplate.Sections.shops', {
          ns: 'newComponents'
        }),
      action: {
        type: ComponentType.link,
        to: projectId
          ? urls.PROJECT.tabs.GROWTH_TOOLS.SHOPS.create({
              projectId
            })
          : '',
        mask: urls.PROJECT.tabs.GROWTH_TOOLS.mask
      }
    },
    {
      Icon: StatsIcon,
      title: (t) =>
        t('PageTemplate.Sections.stats', {
          ns: 'newComponents'
        }),
      action: {
        type: ComponentType.link,
        to: projectId
          ? urls.PROJECT.tabs.STATS.create({
              projectId
            })
          : '',
        mask: urls.PROJECT.tabs.STATS.mask
      }
    },
    {
      Icon: OperatorAnalyticsIcon,
      title: (t) =>
        t('PageTemplate.Sections.operatorAnalytics', {
          ns: 'newComponents'
        }),
      action: {
        type: ComponentType.link,
        to: projectId
          ? urls.PROJECT.tabs.OPERATOR_ANALYTICS.create({
              projectId
            })
          : '',
        mask: urls.PROJECT.tabs.OPERATOR_ANALYTICS.mask
      },
      isNew: true
    },
    {
      Icon: IntegrationsIcon,
      title: (t) =>
        t('PageTemplate.Sections.integrations', {
          ns: 'newComponents'
        }),
      action: {
        type: ComponentType.link,
        to: projectId
          ? urls.PROJECT.tabs.INTEGRATIONS.create({
              projectId,
              integrationTab: IntegrationTypeAll.all
            })
          : '',
        mask: urls.PROJECT.tabs.INTEGRATIONS.mask
      }
    },
    {
      Icon: PaletteIcon,
      title: (t) =>
        t('PageTemplate.Sections.widgetCustomization', {
          ns: 'newComponents'
        }),
      action: {
        type: ComponentType.link,
        to: projectId
          ? urls.PROJECT.tabs.WIDGET_CUSTOMIZATION.create({
              projectId
            })
          : '',
        mask: urls.PROJECT.tabs.WIDGET_CUSTOMIZATION.mask
      }
    },
    {
      Icon: ChannelIcon,
      title: (t) =>
        t('PageTemplate.Sections.channels', {
          ns: 'newComponents'
        }),
      action: {
        type: ComponentType.link,
        to: projectId
          ? urls.PROJECT.tabs.CHANNELS.create({
              projectId
            })
          : '',
        mask: urls.PROJECT.tabs.CHANNELS.mask
      }
    },
    {
      Icon: SettingsIcon,
      title: (t) =>
        t('PageTemplate.Sections.projectSettings', {
          ns: 'newComponents'
        }),
      action: {
        type: ComponentType.link,
        to: projectId
          ? urls.PROJECT.tabs.SETTINGS.COMMON.create({
              projectId
            })
          : '',
        mask: urls.PROJECT.tabs.SETTINGS.mask
      }
    }
  ];
};
